import { IterableIteratorSlots, IteratorResultSlots } from '../../constants';
import { Helper } from '../Helper';
export class IterableIteratorReduceHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.unwrapIterableIterator);
        sb.emitPushInt(node, IterableIteratorSlots.next);
        sb.emitOp(node, 'PICKITEM');
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'NEWARRAY');
        sb.emitOp(node, 'ROT');
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'OVER');
                sb.emitHelper(node, options, sb.helpers.call);
                sb.emitHelper(node, options, sb.helpers.unwrapIteratorResult);
                sb.emitOp(node, 'DUP');
                sb.emitPushInt(node, IteratorResultSlots.done);
                sb.emitOp(node, 'PICKITEM');
                sb.emitHelper(node, options, sb.helpers.unwrapBoolean);
                sb.emitOp(node, 'NOT');
                sb.emitPushInt(node, 3);
                sb.emitOp(node, 'ROLL');
                sb.emitOp(node, 'SWAP');
            },
            each: (innerOptions) => {
                sb.emitOp(node, 'SWAP');
                sb.emitPushInt(node, IteratorResultSlots.value);
                sb.emitOp(node, 'PICKITEM');
                sb.emitPushInt(node, 0);
                sb.emitOp(node, 'NEWARRAY');
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'ROT');
                this.each(sb.noPushValueOptions(innerOptions));
            },
            handleReturn: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
            },
            cleanup: () => {
                sb.emitOp(node, 'NIP');
                sb.emitOp(node, 'NIP');
                if (!optionsIn.pushValue) {
                    sb.emitOp(node, 'DROP');
                }
            },
        }));
    }
}

//# sourceMappingURL=IterableIteratorReduceHelper.js.map
